import {NgModule} from "@angular/core";
import {MøteprotokollStatusKomponentAvhengigheter} from "./komponenter/møteprotokoll-status/møteprotokoll-status";
import {MøteprotokollSendTilSigneringDialogKomponentAvhengigheter} from "web-ng2/moduler/møteprotokoll/modale/møteprotokoll-send-til-signering-dialog/møteprotokoll-send-til-signering-dialog";
import {MøteprotokollRedigerKomponentAvhengigheter} from "web-ng2/moduler/møteprotokoll/komponenter/møteprotokoll-rediger/møteprotokoll-rediger";
import {MøteprotokollRedigerSaksreferatKomponentAvhengigheter} from "web-ng2/moduler/møteprotokoll/komponenter/møteprotokoll-rediger-saksreferat/møteprotokoll-rediger-saksreferat";
import {MøteprotokollVisKomponentAvhengigheter} from "web-ng2/moduler/møteprotokoll/komponenter/møteprotokoll-vis/møteprotokoll-vis";
import {MøteprotokollSignatarKomponentAvhengigheter} from "web-ng2/moduler/møteprotokoll/komponenter/møteprotokoll-signatar/møteprotokoll-signatar";
import {MøteprotokollSaksreferatKomponentAvhengigheter} from "web-ng2/moduler/møteprotokoll/komponenter/møteprotokoll-saksreferat/møteprotokoll-saksreferat";

@NgModule({
    providers: [
        MøteprotokollStatusKomponentAvhengigheter,
        MøteprotokollSendTilSigneringDialogKomponentAvhengigheter,
        MøteprotokollRedigerKomponentAvhengigheter,
        MøteprotokollRedigerSaksreferatKomponentAvhengigheter,
        MøteprotokollVisKomponentAvhengigheter,
        MøteprotokollSignatarKomponentAvhengigheter,
        MøteprotokollSaksreferatKomponentAvhengigheter
    ]
})
export class MøteprotokollModul{

}
